import React, { useState } from "react";

import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import download from "downloadjs";
import _ from "lodash";
import PropTypes from "prop-types";
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { Chart } from "react-google-charts";
import { FormattedMessage, injectIntl } from "react-intl";
import ObjectUtils from "../../../../utils/ObjectUtils";

const ProgramChart = ({ title, chartProps, visualization, details, questionType, useZAxisValue }) => {
  const [imageUri, setImageUri] = useState(null);

  const handleChartData = (data) => {
    let dataCopy = [["name", title]];
    if (data instanceof Array) {
      data.forEach(function (row) {
        if (row.xaxisValue && row.yaxisValue) {
          dataCopy.push([row.xaxisInfo || row.xaxisValue, row.yaxisValue]);
        }
      });
    }

    return dataCopy;
  };

  const downloadChart = () => {
    download(imageUri, "chart.png", "image/png");
  };

  const handleChartDetailData = (data, details) => {
    let res = [];
    const tableHeaderRows =
      data?.data?.map((d) => ({
        value: d.xaxisValue,
        label: d.xaxisInfo || d.xaxisValue
      })) || [];
    const newArray = _.groupBy(details, "zaxisValue");
    res[0] = [];
    res[0][0] = "x-axis";
    tableHeaderRows?.forEach((row, index) => {
      res[0][index + 1] = row.label;
    });
    if (tableHeaderRows.length > 1) {
      Object.keys(newArray).forEach((key) => {
        let tmp = [];
        tmp[0] = useZAxisValue ? key : newArray[key][0].zaxisInfo || key;
        tableHeaderRows?.forEach((row, index) => {
          let e = ObjectUtils.findByObjectProp(newArray[key], "xaxisValue", row.value);
          tmp[index + 1] = e.yaxisValue ? e.yaxisValue : 0;
        });
        res.push(tmp);
      });
    } else {
      Object.keys(newArray).forEach((key) => {
        let tmp = [];
        tmp[0] = useZAxisValue ? key : newArray[key][0].zaxisInfo || key;
        tmp[1] = newArray[key][0].yaxisValue;
        res.push(tmp);
      });
    }
    return res;
  };

  let data;
  if (visualization?.data) {
    data = visualization.data;
  } else if (visualization?.anwser?.anwserList) {
    data = visualization.anwser.anwserList;
  }
  chartProps.options.hAxis.title = title;
  return (
    <>
      <div className="bg-light p-2">
        {data ? (
          <Chart
            className={"chart border"}
            chartType={chartProps?.chartType}
            width={chartProps?.width}
            height={chartProps?.height}
            rows={chartProps?.rows}
            columns={chartProps?.columns}
            data={details ? handleChartDetailData(visualization, details) : handleChartData(data)}
            options={chartProps.options}
            legendToggle={false}
            chartEvents={visualization.chartEvents}
            chartPackages={["corechart", "controls", "table", "timeline", "treemap", "wordtree", "gantt"]}
            chartLanguage={"de"}
            getChartWrapper={(chartWrapper, google) => {
              google.visualization.events.addOneTimeListener(chartWrapper, 'ready', (function() {
                const chartImageURI =
                  chartWrapper.getChart() && typeof chartWrapper.getChart().getImageURI === "function"
                    ? chartWrapper.getChart().getImageURI()
                    : null;
                    setImageUri(chartImageURI);
              }));
              chartWrapper.draw();
            }}
          />
        ) : (
          <div className={"chart--name"}>
            <i>{"Keine Daten für diese Filterauswahl."}</i>
          </div>
        )}
      </div>
      {imageUri && (
        <ButtonToolbar className="bg-light w-100 border-top">
          <ButtonGroup>
            <Button variant="light" onClick={() => downloadChart()}>
              <FormattedMessage id="app.common.action.download" />
              <FontAwesomeIcon icon={faDownload} className="ms-2" />
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      )}
    </>
  );
};

ProgramChart.propTypes = {
  chartProps: PropTypes.object,
  visualization: PropTypes.object,
  details: PropTypes.object,
  questionType: PropTypes.string,
  useZAxisValue: PropTypes.bool
};

export default injectIntl(ProgramChart);
